import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PopupBenefitBlockData from '../../../Models/Content/PopupBenefitBlockData';
import PopUpBenefitMain from './PopupBenefitMain';
export default class PopupBenefitBlock extends EpiComponent<PopupBenefitBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    //develop popup benefit
    return <PopUpBenefitMain context={this.getContext()} iContent={this.props.data} />;

    //develop update contact and account details
  }
}
